// extracted by mini-css-extract-plugin
export var Container = "ads-module--Container--1dz6t";